<template>
    <div class="bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-5">
        <!-- Main Image Display -->
        <NuxtImg :src="productImages[selectedImage]?.src || '/placeholder.svg'" :alt="productImages[selectedImage]?.alt"
            width="280" height="280" class="mx-auto transition-opacity duration-500" loading="lazy" />

        <!-- Thumbnail Navigation -->
        <div class="flex gap-3 justify-center mt-4">
            <button v-for="(image, index) in productImages" :key="image.id" @click="selectedImage = index"
                class="relative w-14 h-14 rounded-lg overflow-hidden border-2 transition-all duration-200" :class="selectedImage === index
                    ? 'border-blue-400 ring-2 ring-blue-400/30'
                    : 'border-slate-600 hover:border-slate-400'">
                <NuxtImg :src="image.src || '/placeholder.svg'" :alt="image.alt" class="object-cover w-full h-full" loading="lazy" />
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">

const productImages = [
    {
        id: 1,
        src: "/images/product-showcase/watch.png",
        alt: "Luxury Watch - Main View",
    },
    {
        id: 2,
        src: "/images/product-showcase/watch.png",
        alt: "Luxury Watch - Side View",
    },
    {
        id: 3,
        src: "/images/product-showcase/watch.png",
        alt: "Luxury Watch - Back View",
    },
    {
        id: 4,
        src: "/images/product-showcase/watch.png",
        alt: "Luxury Watch - Detail View",
    },
]

const selectedImage = ref(0)
let interval: NodeJS.Timeout | null = null

onMounted(() => {
    interval = setInterval(() => {
        selectedImage.value = (selectedImage.value + 1) % productImages.length
    }, 3000) // change every 3 seconds
})

onUnmounted(() => {
    if (interval) clearInterval(interval)
})
</script>
